import { useEffect, useState } from 'react';
import BasicInputNumberMask from '../../General/AntComponents/Form/BasicInputNumberMask';
import { stripNonNumeric } from '../../Helpers/Calculations';
import './TextInputStyle.css';

const inputClassName = 'basicinput_de ant-input';
const inputErrorClassName = 'basicinput_de ant-input ant-input-status-error';

//takes an onChange prop and calls it with (dataKey, newValue)
const SsnInput = props => {
    const { def, dataKey, data, onChange, state } = props;
    const [className, setClassName] = useState(inputClassName);

    useEffect(() => {
        checkSsn(data);
        
    }, [])

    const checkSsn = value => {
        const raw = stripNonNumeric(value);

        if (isNaN(raw) && raw !== '') return;
        if (raw.length > 9) return;

        const lenWarning = `"${def.label}" must be 9 digits`;

        const newWarning = raw.length > 0
            ? raw.length < 9 ? lenWarning : ''
            : state.required ? lenWarning : '';

        if ((newWarning !== undefined && newWarning !== '') || (state.required && raw.length === 0)) {
            setClassName(inputErrorClassName);
        }
        else {
            setClassName(inputClassName);
        }

        onChange(dataKey, raw, newWarning);
    }

    return <span className='ant-input-wrapper'>
        <BasicInputNumberMask
            className={className}
            id={def.dataKey}
            data-input='ssninput_de'
            mask='000-00-0000'
            readOnly={state.readonly}
            disabled={state.readonly}
            useUnmaskedValue={true}
            onChange={value => checkSsn(value)}
            placeholder='###-##-####'
            placeholderChar='#'
            value={data}
        />
    </span>
}

export default SsnInput;
